import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v4/admin/ai-questions/`;
export const QueryKey = (params?: {
    page: number;
    page_size: number;
    filters?: { robot?: string; product?: string; vendor?: string };
}) => ['v4', 'admin', 'ai-questions', params] as const;
export type Payload = never;
export type Response = Models.AiQuestions.AiQuestionPage;
